import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint0_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M135.85 169.8c-5.83-6.17-18.71-12.43-32.97-12.62-7.76-.1-14.97-.23-24.92 3.81-4.33 1.76-14.34 6.38-16.24 7.64a5.4 5.4 0 0 1 2.81-.79c6.8 0 9.9 12.29 9.9 23.7V195h67.04v-3.46c0-6.44-1.12-17.17-5.62-21.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-dark, #D9401C)",
			d: "M64.53 167.84c-6.8 0-9.89 12.29-9.89 23.7V195h19.79v-3.46c0-11.41-3.1-23.7-9.9-23.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint1_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M64.53 167.84c-6.8 0-9.89 12.29-9.89 23.7V195h19.79v-3.46c0-11.41-3.1-23.7-9.9-23.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M64.53 172.64c-1.48 0-5.09 6.63-5.09 18.9V195h10.19v-3.46c0-12.28-3.62-18.9-5.1-18.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint2_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M64.53 172.64c-1.48 0-5.09 6.63-5.09 18.9V195h10.19v-3.46c0-12.28-3.62-18.9-5.1-18.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M90.17 155.7v4.2c0 2.53 4.93 4.6 11 4.6s11-2.06 11-4.6v-4.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint3_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M90.17 155.7v4.2c0 2.53 4.93 4.6 11 4.6s11-2.06 11-4.6v-4.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint4_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M72.49 102.74h-9.36a7.25 7.25 0 0 0-7.25 7.25v31.42a7.24 7.24 0 0 0 5.21 6.95L79.85 155q1.47.69 3.08.68h56.29a7.25 7.25 0 0 0 7.25-7.25v-31.41a7.2 7.2 0 0 0-4.77-6.8c.09-.02.38.12-14.67-5.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint5_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M139.22 109.78H82.93c-4 0-7.25 3.25-7.25 7.25v31.41c0 4 3.25 7.25 7.25 7.25h56.29c4 0 7.25-3.24 7.25-7.25v-31.41c0-4-3.25-7.25-7.25-7.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint6_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M137.71 124.74H84.44v16h53.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-dark, #D9401C)",
			d: "M132.28 124.74H84.44v13.75h47.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint7_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M132.28 124.74H84.44v13.75h47.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M93.44 129.6a2.34 2.34 0 1 0 1.76 2.27 2.07 2.07 0 0 0-1.76-2.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint8_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M93.44 129.6a2.34 2.34 0 1 0 1.76 2.27 2.07 2.07 0 0 0-1.76-2.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M123.9 129.6a2.34 2.34 0 1 0 1.77 2.27 2.07 2.07 0 0 0-1.77-2.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint9_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.9 129.6a2.34 2.34 0 1 0 1.77 2.27 2.07 2.07 0 0 0-1.77-2.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M101.97 133.04c3.25 2.17 10.27 2.17 13.52 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint10_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.97 133.04c3.25 2.17 10.27 2.17 13.52 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint11_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m132.28 138.48 5.43 2.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint12_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M84.74 6.44a10.7 10.7 0 0 1 7.28 7.34c.9 3.3.15 6.8.37 10.22.55 8.98 8.79 10.79 12.74 3.02 1.44-2.81 2.02-6.03 3.65-8.73 3.3-5.48 8.56-8.24 18.22-7.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint13_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m120.14 17.96 6.86-7.08L119.08 5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint14_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M30.04 67.9c-.73-5.58-1.46-11.26-.57-16.82 2.94-18.32 20.39-19.63 27.47-10.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint15_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m47.11 39.87 9.83.75-.53-9.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint16_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M155.92 34.34a10.9 10.9 0 0 1 6.68 7.46c.84 3.37-.9 7.87-4.19 11.3-4.4 4.59-20.59 10.05-3.33 21.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint17_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m145.23 74.32 9.86.14-1.16-9.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint18_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m44.28 88.51-8.61 3.43a12.94 12.94 0 1 0 4.16 3.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#sa-unavailable_svg__paint19_linear_4001_7635)",
			d: "M27.75 111c-.05 0-4.25-.54-4.25-2.6 0-1.82 2.41-2.46 4.25-2.7zm0-16s8.23 1.1 8.23 5.34-6.4 5.12-8.23 5.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint20_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M181.86 93.25a12.96 12.96 0 0 0-22.95-2.9l-8.12-1.85 6.1 6.98a12.92 12.92 0 0 0 19.47 13.14 12.94 12.94 0 0 0 5.5-15.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint21_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.93 96.28a5.6 5.6 0 1 0 3.6-4.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint22_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m166.26 98.6-2.33-2.32-3.25 1.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M70.2 13.74a5.45 5.45 0 1 0-.23 10.9 5.45 5.45 0 0 0 .22-10.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint23_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M70.2 13.74a5.45 5.45 0 1 0-.23 10.9 5.45 5.45 0 0 0 .22-10.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-dark, #D9401C)",
			d: "M139.35 16.33a5.45 5.45 0 1 0-.22 10.89 5.45 5.45 0 0 0 .22-10.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint24_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M139.35 16.33a5.45 5.45 0 1 0-.22 10.89 5.45 5.45 0 0 0 .22-10.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint25_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M43.47 133.36c.66 0 1.2-.55 1.2-1.23 0-.69-.54-1.24-1.2-1.24-.67 0-1.22.55-1.22 1.24s.55 1.23 1.22 1.23"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint26_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M174.3 66.91c1.21 0 2.2-1 2.2-2.25 0-1.24-.99-2.25-2.2-2.25s-2.2 1.01-2.2 2.25c0 1.25.98 2.25 2.2 2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint27_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m161.6 177.16 6.99 6.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint28_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m161.6 184.14 6.99-6.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint29_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m26.28 157.12 3.56 3.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint30_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m26.28 160.68 3.56-3.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint31_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M178.09 144.22h5.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint32_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M180.78 146.91v-5.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint33_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M121.47 44.67a1.2 1.2 0 1 0-.05 2.4 1.2 1.2 0 0 0 .05-2.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M81.75 107.32h-5.92c.1-3.76-10.05-8.83-16.83-13.66C51.06 88 44.45 81.13 41.51 74.6c-4.26-9.49-2.11-22.24 8.37-25.57 5.99-1.9 12.35 1.52 14.8 7.97.75 1.99.85 5.13.96 9.11.17 5.68.48 16.25 4.2 16.66 3.92.44 4.26-4.58 2.98-8.35a89 89 0 0 1-4.1-15.45c-.86-5.61-1.68-15.77 2.48-20.65a10.4 10.4 0 0 1 7.74-3.95c2.81-.06 5.54.98 7.6 2.9 3.62 3.8 3.73 8.77 3.5 12.18q-.41 3.96-1.8 7.67c-1.3 3.96-2.79 8.94-1.5 12.97 1.2 3.8 2.93 5.33 4.7 5.42 1.75.1 3.96-1.04 5.14-3.76 2.73-6.34 3.92-13.81 5.14-19.37 4.63-21.1 30.09-30.19 38.05-9.02 5.6 14.88-14.7 21.84-19.15 24.61-6.14 3.81-13.64 10.25-9.68 16.25a4.4 4.4 0 0 0 3.26 1.26c2.38 0 4.72-1.54 6.77-4.44 5.69-8.05 11.24-8.44 14.03-7.96a9.6 9.6 0 0 1 7.52 6.45c1.63 5.84-3.88 11.95-9.2 17.86-3.15 3.5-7.15 7.8-7.18 9.94l-5.97-.04c.05-4.42 4.22-9.05 8.65-13.96 3.63-4.03 8.6-9.54 7.87-12.17a3.6 3.6 0 0 0-2.72-2.1c-2.4-.42-5.25 1.53-8.05 5.48-4.37 6.18-9.33 7.03-11.9 7-3.33-.05-6.6-1.65-8.13-3.98a12.2 12.2 0 0 1-1.8-9.56c1.16-5.29 5.65-10.4 13.34-15.17.9-.57 2.13-1.17 3.55-1.87 8.08-4 15.75-8.48 13.13-15.46-2.12-5.63-5.74-8.43-10.46-8.1-6.2.45-13.9 6.67-16 16.29-1.18 5.4-2.45 13.4-5.5 20.46-2.24 5.2-6.6 7.64-11 7.42-2.62-.13-7.38-.87-10.18-9.63-2.82-8.83 2.65-17.42 3.02-22.9.18-2.6.1-5.55-1.84-7.57a5 5 0 0 0-3.1-1.04 4.5 4.5 0 0 0-3.24 1.82c-1.78 2.1-2.23 8.45-1.1 15.81a84 84 0 0 0 3.85 14.42c1.71 5.06 1.21 9.97-1.34 13.14a8.7 8.7 0 0 1-8.04 3.18c-12.4-1.36-8.48-25.22-10.16-29.64-1.3-3.45-4.37-5.28-7.3-4.35a8 8 0 0 0-5.08 4.58c-1.56 3.49-1.4 8.72.41 12.73 2.26 5.04 8.54 11.67 15.48 16.62 9.56 6.82 19.4 11.61 19.22 18.58"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint34_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.75 107.32h-5.92c.1-3.76-10.05-8.83-16.83-13.66C51.06 88 44.45 81.13 41.51 74.6c-4.26-9.49-2.11-22.24 8.37-25.57 5.99-1.9 12.35 1.52 14.8 7.97.75 1.99.85 5.13.96 9.11.17 5.68.48 16.25 4.2 16.66 3.92.44 4.26-4.58 2.98-8.35a89 89 0 0 1-4.1-15.45c-.86-5.61-1.68-15.77 2.48-20.65a10.4 10.4 0 0 1 7.74-3.95c2.81-.06 5.54.98 7.6 2.9 3.62 3.8 3.73 8.77 3.5 12.18q-.41 3.96-1.8 7.67c-1.3 3.96-2.79 8.94-1.5 12.97 1.2 3.8 2.93 5.33 4.7 5.42 1.75.1 3.96-1.04 5.14-3.76 2.73-6.34 3.92-13.81 5.14-19.37 4.63-21.1 30.09-30.19 38.05-9.02 5.6 14.88-14.7 21.84-19.15 24.61-6.14 3.81-13.64 10.25-9.68 16.25a4.4 4.4 0 0 0 3.26 1.26c2.38 0 4.72-1.54 6.77-4.44 5.69-8.05 11.24-8.44 14.03-7.96a9.6 9.6 0 0 1 7.52 6.45c1.63 5.84-3.88 11.95-9.2 17.86-3.15 3.5-7.15 7.8-7.18 9.94l-5.97-.04c.05-4.42 4.22-9.05 8.65-13.96 3.63-4.03 8.6-9.54 7.87-12.17a3.6 3.6 0 0 0-2.72-2.1c-2.4-.42-5.25 1.53-8.05 5.48-4.37 6.18-9.33 7.03-11.9 7-3.33-.05-6.6-1.65-8.13-3.98a12.2 12.2 0 0 1-1.8-9.56c1.16-5.29 5.65-10.4 13.34-15.17.9-.57 2.13-1.17 3.55-1.87 8.08-4 15.75-8.48 13.13-15.46-2.12-5.63-5.74-8.43-10.46-8.1-6.2.45-13.9 6.67-16 16.29-1.18 5.4-2.45 13.4-5.5 20.46-2.24 5.2-6.6 7.64-11 7.42-2.62-.13-7.38-.87-10.18-9.63-2.82-8.83 2.65-17.42 3.02-22.9.18-2.6.1-5.55-1.84-7.57a5 5 0 0 0-3.1-1.04 4.5 4.5 0 0 0-3.24 1.82c-1.78 2.1-2.23 8.45-1.1 15.81a84 84 0 0 0 3.85 14.42c1.71 5.06 1.21 9.97-1.34 13.14a8.7 8.7 0 0 1-8.04 3.18c-12.4-1.36-8.48-25.22-10.16-29.64-1.3-3.45-4.37-5.28-7.3-4.35a8 8 0 0 0-5.08 4.58c-1.56 3.49-1.4 8.72.41 12.73 2.26 5.04 8.54 11.67 15.48 16.62 9.56 6.82 19.4 11.61 19.22 18.58"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-dark, #D9401C)",
			d: "M89.72 88.98a3.45 3.45 0 1 0-.14 6.9 3.45 3.45 0 0 0 .14-6.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint35_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M89.72 88.98a3.45 3.45 0 1 0-.14 6.9 3.45 3.45 0 0 0 .14-6.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent-light, #B1337A)",
			d: "M123.46 106.1H70.2l3.7 1.21h53.26z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-unavailable_svg__paint36_linear_4001_7635)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.46 106.1H70.2l3.7 1.21h53.26z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint0_linear_4001_7635",
				x1: 101.596,
				x2: 101.165,
				y1: 189.37,
				y2: 163.998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint1_linear_4001_7635",
				x1: 64.533,
				x2: 63.64,
				y1: 190.961,
				y2: 172.796,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint2_linear_4001_7635",
				x1: 64.533,
				x2: 63.362,
				y1: 191.675,
				y2: 176.777,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint3_linear_4001_7635",
				x1: 101.172,
				x2: 101.087,
				y1: 163.185,
				y2: 157.285,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint4_linear_4001_7635",
				x1: 101.173,
				x2: 100.43,
				y1: 147.818,
				y2: 112.331,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint5_linear_4001_7635",
				x1: 111.075,
				x2: 110.36,
				y1: 148.864,
				y2: 118.097,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint6_linear_4001_7635",
				x1: 111.076,
				x2: 110.961,
				y1: 138.358,
				y2: 127.632,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint7_linear_4001_7635",
				x1: 108.361,
				x2: 108.267,
				y1: 136.441,
				y2: 127.224,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint8_linear_4001_7635",
				x1: 92.868,
				x2: 92.755,
				y1: 133.517,
				y2: 130.379,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint9_linear_4001_7635",
				x1: 123.329,
				x2: 123.217,
				y1: 133.518,
				y2: 130.379,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint10_linear_4001_7635",
				x1: 108.73,
				x2: 108.725,
				y1: 134.423,
				y2: 133.331,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint11_linear_4001_7635",
				x1: 134.996,
				x2: 134.973,
				y1: 140.401,
				y2: 138.892,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint12_linear_4001_7635",
				x1: 105.87,
				x2: 105.501,
				y1: 28.13,
				y2: 11.05,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint13_linear_4001_7635",
				x1: 123.04,
				x2: 122.531,
				y1: 16.034,
				y2: 7.373,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint14_linear_4001_7635",
				x1: 43.001,
				x2: 42.074,
				y1: 63.016,
				y2: 41.036,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint15_linear_4001_7635",
				x1: 52.028,
				x2: 51.792,
				y1: 39.157,
				y2: 32.563,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint16_linear_4001_7635",
				x1: 155.053,
				x2: 152.582,
				y1: 68.493,
				y2: 41.818,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint17_linear_4001_7635",
				x1: 150.156,
				x2: 149.923,
				y1: 73,
				y2: 66.442,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint18_linear_4001_7635",
				x1: 30.404,
				x2: 29.74,
				y1: 112.106,
				y2: 93.545,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint19_linear_4001_7635",
				x1: 23.5,
				x2: 30.079,
				y1: 95,
				y2: 113.141,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-ramp-1, #FF8164)" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .508,
						stopColor: "var(--illu-error-ramp-2, #FF6642)",
						stopOpacity: .97
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .876,
						stopColor: "var(--illu-error-ramp-3, #FF542C)",
						stopOpacity: .93
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "var(--illu-error-ramp-4, #F2471F)"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint20_linear_4001_7635",
				x1: 166.693,
				x2: 166.188,
				y1: 106.648,
				y2: 89.323,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint21_linear_4001_7635",
				x1: 169.393,
				x2: 169.124,
				y1: 101.429,
				y2: 93.929,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint22_linear_4001_7635",
				x1: 163.469,
				x2: 163.446,
				y1: 98.257,
				y2: 96.698,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint23_linear_4001_7635",
				x1: 70.081,
				x2: 69.82,
				y1: 23.009,
				y2: 15.713,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint24_linear_4001_7635",
				x1: 139.244,
				x2: 138.983,
				y1: 25.6,
				y2: 18.303,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint25_linear_4001_7635",
				x1: 43.466,
				x2: 43.405,
				y1: 132.995,
				y2: 131.34,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint26_linear_4001_7635",
				x1: 174.298,
				x2: 174.188,
				y1: 66.243,
				y2: 63.231,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint27_linear_4001_7635",
				x1: 165.097,
				x2: 164.929,
				y1: 183.101,
				y2: 178.424,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint28_linear_4001_7635",
				x1: 165.097,
				x2: 164.929,
				y1: 183.101,
				y2: 178.424,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint29_linear_4001_7635",
				x1: 28.06,
				x2: 27.974,
				y1: 160.15,
				y2: 157.765,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint30_linear_4001_7635",
				x1: 28.06,
				x2: 27.974,
				y1: 160.15,
				y2: 157.765,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint31_linear_4001_7635",
				x1: 180.779,
				x2: 180.775,
				y1: 145.071,
				y2: 144.401,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint32_linear_4001_7635",
				x1: 181.28,
				x2: 180.608,
				y1: 146.112,
				y2: 142.63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint33_linear_4001_7635",
				x1: 121.446,
				x2: 121.389,
				y1: 46.704,
				y2: 45.105,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint34_linear_4001_7635",
				x1: 91.132,
				x2: 89.79,
				y1: 96.01,
				y2: 45.08,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint35_linear_4001_7635",
				x1: 89.651,
				x2: 89.485,
				y1: 94.861,
				y2: 90.234,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-unavailable_svg__paint36_linear_4001_7635",
				x1: 98.672,
				x2: 98.671,
				y1: 107.133,
				y2: 106.315,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default SvgSaUnavailable;
